var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.auth
    ? _c(
        "div",
        { attrs: { id: "bankrupt-tile" } },
        [
          _vm.isBankrupt
            ? _c(
                "span",
                {
                  staticClass: "bankrupt__message",
                  on: {
                    click: function ($event) {
                      return _vm.openModal()
                    },
                  },
                },
                [_vm._v("\n\t\t\tСообщения о банкротстве\n\t\t")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modal_show
            ? _c(
                "modal",
                {
                  attrs: {
                    close: function () {
                      _vm.modal_show = false
                    },
                    printButton: true,
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "modalHeader" }, slot: "modalHeader" },
                    [
                      _c("h3", [
                        _c("i", {
                          staticClass: "uk-icon-gavel",
                          attrs: { id: "gavel__icon" },
                        }),
                        _vm._v(
                          " \n                    Сообщения о банкротстве\n                "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { padding: "10px" },
                      attrs: {
                        slot: "modalBody",
                        id: "modal-company-bankrupt",
                      },
                      slot: "modalBody",
                    },
                    [
                      _vm.paginationModal && _vm.messages.length
                        ? _c("pagination", {
                            attrs: {
                              pagination: _vm.paginationModal,
                              onTurnPageCallBack: _vm.getData,
                              showRowsPerPageSelection: false,
                              rows_on_page: _vm.messages.length,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm.messages.length
                          ? _c(
                              "div",
                              _vm._l(_vm.messages, function (e, i) {
                                return _c("div", { key: i }, [
                                  _c(
                                    "p",
                                    {
                                      class:
                                        "hide-bankrupt-texts" +
                                        (e.text || e.annul_text)
                                          ? ""
                                          : " load-bankrupt-texts",
                                      attrs: {
                                        id: "bankrupt-event-id" + i,
                                        "data-id": i,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showDescription(i, $event)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "date bold__date" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                e.annul == 1
                                                  ? _vm.dateFormat(e.date_annul)
                                                  : _vm.dateFormat(
                                                      e.date_publish
                                                    )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          class:
                                            "name" +
                                            (_vm.stopFactors.indexOf(
                                              e.type_event
                                            ) != -1
                                              ? " red"
                                              : ""),
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                e.event_text +
                                                  (e.annul == 1
                                                    ? " (аннулировано)"
                                                    : "")
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          ref: "down",
                                          refInFor: true,
                                          staticClass: "status_hide no_print",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Развернуть \n                                    "
                                          ),
                                          _c("i", {
                                            staticClass: "uk-icon-chevron-down",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          ref: "up",
                                          refInFor: true,
                                          staticClass: "status_hide no_print",
                                          staticStyle: { display: "none" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    Свернуть \n                                    "
                                          ),
                                          _c("i", {
                                            staticClass: "uk-icon-chevron-up",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  e.annul == 1 || e.annul_text
                                    ? _c(
                                        "pre",
                                        {
                                          ref: "description",
                                          refInFor: true,
                                          staticClass:
                                            "bankrupt-texts no_print-pre",
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            id: "bankrupt-texts-id" + i,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "                                " +
                                              _vm._s(e.annul_text) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : !e.annul == 1 || e.text
                                    ? _c(
                                        "pre",
                                        {
                                          ref: "description",
                                          refInFor: true,
                                          staticClass:
                                            "bankrupt-texts no_print-pre",
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            id: "bankrupt-texts-id" + i,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "                                " +
                                              _vm._s(e.text) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "pre",
                                        {
                                          ref: "description",
                                          refInFor: true,
                                          staticClass:
                                            "bankrupt-texts no_print-pre",
                                          staticStyle: { display: "none" },
                                          attrs: {
                                            id: "bankrupt-texts-id" + i,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "                                "
                                          ),
                                          _vm.loading
                                            ? _c("shestirenkaLoader")
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                            "
                                          ),
                                        ],
                                        1
                                      ),
                                ])
                              }),
                              0
                            )
                          : _vm.loading
                          ? _c(
                              "div",
                              [
                                _vm.loading
                                  ? _c("shestirenkaLoader")
                                  : _vm._e(),
                              ],
                              1
                            )
                          : !_vm.messages.length && _vm.empty
                          ? _c("div", [
                              _c("i", {
                                staticClass: "uk-icon-check",
                                staticStyle: {
                                  color: "#bcf2db",
                                  "font-size": "30px",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    color: "#777",
                                  },
                                },
                                [_vm._v("Сообщения о банкротстве не найдены.")]
                              ),
                            ])
                          : _vm.error
                          ? _c("div", [
                              _c("i", {
                                staticClass: "uk-icon-exclamation-triangle",
                                staticStyle: {
                                  color: "#999",
                                  "font-size": "30px",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    color: "#777",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Не удалось загрузить сообщения о банкротстве."
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "Попробуйте повторить запрос позже или обратитесь в службу технической поддержки."
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.paginationModal && _vm.messages.length
                        ? _c("pagination", {
                            attrs: {
                              pagination: _vm.paginationModal,
                              onTurnPageCallBack: _vm.getData,
                              showRowsPerPageSelection: false,
                              rows_on_page: _vm.messages.length,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }